import './QuantitativeIndicatorUnit.css';

import { Straighten } from '@mui/icons-material';
import { Box } from '@mui/material';
import { generateClassName } from '../../../b2b-common/helpers';

const QuantitativeIndicatorUnit = ({ indicator, showIcon = true, className = null }) => {
    return (
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-start" gap={1}
            className={generateClassName('quantitative-indicator-unit', '', className)}
        >
            {showIcon && (
                <Straighten />
            )}
            <Box className="quantitative-indicator-unit-name" display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                {indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnitName}
            </Box>
            {(indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit !== '') && (indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnitName !== indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit) && (
                <Box className="quantitative-indicator-unit-symbol" display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                    ({indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit})
                </Box>
            )}
        </Box>
    );
}

export default QuantitativeIndicatorUnit;